import { render, staticRenderFns } from "./EcommerceStatistics.vue?vue&type=template&id=a56288d4&scoped=true&"
import script from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
export * from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceStatistics.vue?vue&type=style&index=0&id=a56288d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56288d4",
  null
  
)

export default component.exports